function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  font-size: ", " !important;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n  padding: 0;\n  font-size: ", " !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  user-select: none;\n  font-size: ", ";\n  font-family: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0.3125rem;\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
import { Button } from "../button/Button";
export var SecredFieldWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.fonts.weight.regular;
});
export var SecretText = styled.p(_templateObject2(), function (props) {
  return props.theme.variables.fonts.size.smaller0;
}, function (props) {
  return props.theme.variables.typography.primaryFont;
}, function (props) {
  return props.isReadable ? "\n    color: ".concat(props.theme.variables.colors.black, ";   \n  ") : "\n    color: transparent;\n    text-shadow: 0 0 0.625rem ".concat(props.theme.variables.colors.black, ";\n    text-shadow: 0 0 0.625rem 0.1rem ").concat(props.theme.variables.colors.black, ";\n  ");
});
export var ToggleButton = styled(Button)(_templateObject3(), function (props) {
  return props.theme.variables.fonts.size.smaller1;
});
export var CopyButton = styled(Button)(_templateObject4(), function (props) {
  return props.theme.variables.fonts.size.smaller1;
});